export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/sparkles-icon.png?49cadd4e938a9087967339b7ca97d9d5";